module.exports = "/static/Images/en/Neutral.png";